module.exports = {"Type":"SetVariables","Fields":[{"label":"Variables to set","type":"multiline","name":"text","serializeTo":"q","description":"Assign a value to a variable. For multiple assignments use , as separator. To increment/decrement a number use the notation ++#!variableName!# or --#!variableName!#"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/SetVariables.json
// module id = 672
// module chunks = 0